export const uvNewsConstants = {
    ADD_REQUEST:  'ADD_REQUEST',
    ADD_SUCCESS: 'ADD_SUCCESS',
    ADD_FAILURE: 'ADD_FAILURE', 

    UPDATE_REQUEST: 'UPDATE_REQUEST',
    UPDATE_SUCCESS: 'UPDATE_SUCCESS',

    GET_SUCCESS: 'GET_SUCCESS',
};